import React from 'react'
import PropTypes from 'prop-types'

// Components
import { If, Unless } from '../../../../../../components'
import HomeownerSavingsTile from './HomeownerSavingsTile'
import RenterSavingsTile from './RenterSavingsTile'

// Hooks
import { useListingDisplay } from '../../../../../../hooks/listing'

const SavingsTile = props => {
  const { yearsInHome, savingsValue, totalBuyCost } = useListingDisplay()

  return (
    <>
      <Unless.Own>
        <RenterSavingsTile
          value={savingsValue}
          yearsInHome={yearsInHome}
          {...props}
        />
      </Unless.Own>
      <If.Own>
        <HomeownerSavingsTile
          value={totalBuyCost}
          yearsInHome={yearsInHome}
          {...props}
        />
      </If.Own>
    </>
  )
}

SavingsTile.propTypes = {
  className: PropTypes.string,
}

export default SavingsTile
